import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal } from "antd";
import api from "api";
import { CONFIRMATION_MESSAGES } from "constants";
import useMutation from "hooks/useMutation";

const useBajaAlta = (callback) => {
  const bajaAltaMutation = useMutation({
    mutationFn: api.general.bajaAlta,
    onSuccess: response => {
      if (response.status === 'success') {
        callback && callback()
      }
    },
    onError: err => {
      Modal.error({
        title: err.message || JSON.stringify(err),
      });
    },
  });

  const bajaAlta = (accion, tabla, id, principal) => {
    if (principal) {
      Modal.error({
        title: 'Error',
        icon: <ExclamationCircleFilled />,
        content:
          'No se puede eliminar este registro porque está marcado como principal. ' +
          'Debe asignar otro registro como principal antes de proceder con la eliminación.',
        okText: 'Cerrar',
        maskClosable: false,
        footer: (_, { OkBtn }) => (
          <span style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button
              danger
              onClick={() => {
                Modal.destroyAll(); // cerrar este modal
                confirmarBaja('baja', tabla, id); // abrir el siguiente
              }}
            >
              Eliminar
            </Button>
            <OkBtn />
          </span>
        ),
      });

      return;
    }

    confirmarBaja(accion, tabla, id);
  };

  const confirmarBaja = (accion, tabla, id) => {
    Modal.confirm({
      title: accion === 'alta'
        ? 'Confirmar desestimación de la eliminación'
        : accion === 'baja'
        ? CONFIRMATION_MESSAGES.DELETE_CONFIRMATION
        : 'Confirmar eliminación forzada',
      icon: <ExclamationCircleFilled />,
      okText: 'Si',
      okType: 'danger',
      cancelText: 'No',
      maskClosable: false,
      onOk() {
        bajaAltaMutation.mutate({ accion, tabla, id });
      },
    });
  };

  return {
    bajaAlta,
  }
};

export default useBajaAlta;